import React from 'react';
import { Space, Typography } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

const TimeEndedDisplay = () => {
  const errorColor = '#ef4444'; // A shade of red

  return (
    <Space
      direction="vertical"
      align="center"
      size="middle"
    >
      <ClockCircleOutlined
        style={{
          fontSize: '48px',
          color: errorColor,
        }}
      />
      <Text
        style={{
          fontSize: '20px',
          color: errorColor,
          fontWeight: 500,
        }}
      >
        Time for this section has ended
      </Text>
    </Space>
  );
};

export default TimeEndedDisplay;
